// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__10cy2","head":"Table_head__QsCKl","col":"Table_col__2-8_J"};